import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, {}, {
          headers: { 'X-Session-ID': sessionId },
          withCredentials: true,
        });
        setUser(res.data.user);
        // Clear the hash to avoid replays
        window.history.replaceState({}, document.title, '/dashboard');
        navigate('/dashboard', { replace: true, state: { user: res.data.user } });
      } catch (err) {
        const msg = err.response?.data?.detail || 'Error autenticando con Google';
        toast.error(msg);
        navigate('/login', { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#0052FF] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
        <p className="text-sm text-[#52525B] font-medium">Autenticando...</p>
      </div>
    </div>
  );
}
